import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { Menu01 } from "~/icons";

interface Props {
  btnRef: any;
  onOpen: () => void;
}

export const MobileHeaderIcon: FC<Props> = ({ btnRef, onOpen }) => {
  return (
    <Flex cursor="pointer" onClick={onOpen} ref={btnRef}>
      <Menu01 color="fg-accent" h={5} w={5} />
    </Flex>
  );
};
